import { FC, ReactNode } from 'react'
import {
    GestureResponderEvent,
    Pressable,
    StyleProp,
    StyleSheet,
    Text,
    ViewStyle,
} from 'react-native'
import { TouchableRipple } from 'react-native-paper'
import { FontsEnum } from '../../../constants/fonts'
import { shadow } from '../../../utils/shadow'

interface MenuItem {
    children: ReactNode
    onPress: (event: GestureResponderEvent) => void
    style?: StyleProp<ViewStyle>
}

const MenuItem: FC<MenuItem> = ({ children, onPress, style }) => {
    return (
        <Pressable style={({ hovered, pressed }) => [style, hovered && !pressed && styles.hovered]}>
            <TouchableRipple onPress={onPress} style={styles.container}>
                <Text numberOfLines={1} style={styles.text}>
                    {children}
                </Text>
            </TouchableRipple>
        </Pressable>
    )
}

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 34,
        paddingVertical: 18,
    },
    text: {
        fontFamily: FontsEnum.RUBIK_400_REGULAR,
        fontSize: 16,
    },
    hovered: {
        opacity: 0.94,
        ...shadow({
            elevation: 0,
            color: '#000000',
            offsetHeight: 2,
            offsetWidth: 2,
            opacity: 0.2,
            radius: 6,
            rgba: 'rgba(0, 0, 0, 0.20)',
        }),
    },
})

export default MenuItem
